import { render, staticRenderFns } from "./LoaLevel.vue?vue&type=template&id=0b96ff30&"
import script from "./LoaLevel.vue?vue&type=script&lang=js&"
export * from "./LoaLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b96ff30')) {
      api.createRecord('0b96ff30', component.options)
    } else {
      api.reload('0b96ff30', component.options)
    }
    module.hot.accept("./LoaLevel.vue?vue&type=template&id=0b96ff30&", function () {
      api.rerender('0b96ff30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/LoaLevel.vue"
export default component.exports